module.exports = function getResource(label, vars = []) {
    const resources = {
        submissionError: 'Submission Error',
        thankYou: 'Thank You',
        somethingWentWrongError: 'Something went wrong, please try again later',
        reviewsPostMessage: 'Reviews are typically posted within 72 hours of the time you submit them, so stay tuned. Thank you for helping to make the Sephora community better!',
        continueShopping: 'Continue Shopping'
    };
    return resources[label];
};
